/**
 * Compares 2 given hour strings (HH:MM:SS) to user time (defaulted to Eastern timezone)
 * @param {string} startTime
 * @param {string} endTime
 * @returns {boolean} true if within range, false if outside range
 */
export function compareTimes(startTime, endTime) {
  const now = new Date()

  const [startHours, startMinutes, startSeconds] = startTime
    .split(':')
    .map(Number)
  const [endHours, endMinutes, endSeconds] = endTime.split(':').map(Number)

  const currentEasternHour = parseInt(
    now.toLocaleString('en-US', {
      timeZone: 'America/New_York',
      hour12: false,
      hour: '2-digit',
    }),
    10,
  )
  const currentEasternMinute = parseInt(
    now.toLocaleString('en-US', {
      timeZone: 'America/New_York',
      minute: '2-digit',
    }),
    10,
  )
  const currentEasternSecond = parseInt(
    now.toLocaleString('en-US', {
      timeZone: 'America/New_York',
      second: '2-digit',
    }),
    10,
  )

  const currentEasternTimeInSeconds =
    currentEasternHour * 3600 + currentEasternMinute * 60 + currentEasternSecond
  const startTimeInSeconds =
    startHours * 3600 + startMinutes * 60 + startSeconds
  const endTimeInSeconds = endHours * 3600 + endMinutes * 60 + endSeconds

  // Perform the comparison
  return (
    currentEasternTimeInSeconds >= startTimeInSeconds &&
    currentEasternTimeInSeconds <= endTimeInSeconds
  )
}
